// ASCII, Hiragana, Katakana, Kanji, Kanji Radicals, Katakana and Punctuation, Japanese Symbol and Punctuation, Alphanumeric and Punctuation のみ許可する正規表現
// 参考：https://www.localizingjapan.com/blog/2012/01/20/regular-expressions-for-japanese-text/
const basicCharacterRegexString =
  "\x20-\x7e\u2E80-\u2FD5\u3005\u3041-\u309E\u30A0-\u30FF\u3400-\u4DB5\u4E00-\u9FCB\uF900-\uFA6A\uFF01-\uFF5E\uFF5F-\uFF9F\u3000-\u303F\uFF01-\uFF5E";

export const basicCharacterRegex = new RegExp(
  `^[${basicCharacterRegexString}]+$`
);

export const basicCharacterRegexWithLineBreak = new RegExp(
  `^[${basicCharacterRegexString}\n\r]+$`
);

export const basicCharacterPatternMessage = "絵文字などの特殊文字は使えません";
